import React, { useEffect, useState } from 'react';
import { disclaimersAPI } from '../services/api';

/**
 * Add Block dialog panel: choose a managed disclaimer (Admin > Disclaimers)
 * and add it as a read-only report block.
 */
const DisclaimerBlockPicker = ({ defaultKey, generateBlockId, onAdd, onClose }) => {
  const [types, setTypes] = useState(null);
  const [error, setError] = useState(null);
  const [key, setKey] = useState(defaultKey || '');
  const [fontSize, setFontSize] = useState('7pt');

  useEffect(() => {
    let cancelled = false;
    disclaimersAPI.listTypes('client_report')
      .then((list) => {
        if (cancelled) return;
        setTypes(list);
        if (!list.some((t) => t.key === defaultKey) && list.length) setKey(list[0].key);
      })
      .catch((err) => {
        if (!cancelled) setError(err.response?.data?.detail || 'Could not load disclaimer types');
      });
    return () => { cancelled = true; };
  }, [defaultKey]);

  const handleAdd = () => {
    const t = types.find((x) => x.key === key);
    const blockId = generateBlockId('custom_disclaimer');
    // Kept as a 'text' block so older frontends don't drop it (see ManagedDisclaimerBlock).
    onAdd(blockId, { type: 'text', managedDisclaimer: key, fontSize, label: t ? t.name : key });
    onClose();
  };

  if (error) return <div className="text-block-form" style={{ color: '#F26B43' }}>{error}</div>;
  if (!types) return <div className="text-block-form">Loading disclaimers…</div>;

  return (
    <div className="text-block-form">
      <p style={{ marginTop: 0 }}>
        Adds the disclaimer managed in Admin › Disclaimers. Its text follows the viewer's brand and the
        portfolio's platform, and can't be edited inside the report.
      </p>
      <label className="modal-field-label">
        Disclaimer
        <select value={key} onChange={(e) => setKey(e.target.value)}>
          {types.map((t) => <option key={t.key} value={t.key}>{t.name}</option>)}
        </select>
      </label>
      <label className="modal-field-label">
        Font size
        <select value={fontSize} onChange={(e) => setFontSize(e.target.value)}>
          {['6pt', '6.5pt', '7pt', '7.5pt', '8pt', '9pt', '10pt'].map((s) => <option key={s} value={s}>{s}</option>)}
        </select>
      </label>
      <button className="modal-add-btn" onClick={handleAdd} disabled={!key}>
        Add Disclaimer Block
      </button>
    </div>
  );
};

export default DisclaimerBlockPicker;
